<template>
    <div>
        <config-main-title>
            Cadastro
        </config-main-title>

        <div class="row">
            <div class="col col-12 col-md-4">
                <div class="card">
                    <div class="card-header" :class="step >= 1 ? 'alert-primary' : ''">
                        1. Paciente
                    </div>
                </div>
            </div>

            <div class="col col-12 col-md-4">
                <div class="card">
                    <div class="card-header" :class="step >= 2 ? 'alert-primary' : ''">
                        2. Pedido
                    </div>
                </div>
            </div>

            <div class="col col-12 col-md-4">
                <div class="card">
                    <div class="card-header" :class="step >= 3 ? 'alert-primary' : ''">
                        3. Exames
                    </div>
                </div>
            </div>
        </div>

        <!-- Paciente -->

        <template v-if="step == 1">

            <div class="form-row" v-if="!dados.edicao">
                <div class="col col-12">
                    <az-input
                        v-if="!dados.novo_paciente"
                        placeholder="Informe o nome ou CPF do paciente para pesquisa..."
                        label="Paciente"
                        type="autocomplete"
                        optionsMode="aql"
                        service="pacientes.index"
                        optionsDisplay="search"
                        ref="info_paciente"
                        required
                        :validate="validate"
                        v-model="sel_paciente"
                        :optimized_ac="true"
                        @onEnter="focusOn('info_plano')"
                        @input="selecionarPaciente()">
                        <template v-slot:buttonposb v-if="step == 1">
                            <div class="input-group-append">
                                <button class="btn btn-outline-primary" type="button" id="button-addon2" 
                                    @click="toggle_incluir_paciente()" 
                                    :disabled="!!dados.paciente"
                                    title="Incluir Paciente">
                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>

                    <az-input
                        v-else
                        ref="info_paciente"
                        placeholder="Informe os dados do paciente..."
                        label="Paciente"
                        type="text"
                        v-model="dados.paciente.st_nome"
                        :edicao="false"
                        :validate="validate"
                        :rules="['nome']">
                        <template v-slot:buttonposb v-if="step == 1">
                            <div class="input-group-append">
                                <button class="btn btn-outline-primary" type="button" id="button-addon2" 
                                    @click="toggle_incluir_paciente()" 
                                    title="Pesquisar Paciente">
                                    <i class="fa fa-search" aria-hidden="true"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>
                </div>
            </div>

            <div class="mt-3" v-if="dados.paciente && dados.paciente.cadastro">
                <cadastro-paciente
                    v-model="dados.paciente"
                    marcacao2="marcacao"
                    formName="cadpac"
                    :editar="true"
                    :noButtons="true"
                    ref="cadPaciente"
                    validate2="validate"
                    :sus_block_obrig="true"
                    :block_operadora="true"
                  />
            </div>

            <template v-if="1==0">

                <div class="row">
                    <div class="col col-12" :class="is_sus ? 'col-md-3' : 'col-md-6'">
                        <az-input
                            type="cpf"
                            label="CPF"
                            required
                            :validate="validate" 
                            v-model="dados.paciente.cadastro.st_cpf" />
                    </div>
                    <div class="col col-12 col-md-3" v-if="is_sus">
                        <az-input
                            label="Cartão SUS (CNS)"
                            type="cns" 
                            :validate="validate" 
                            required
                            v-model="dados.cartao_sus" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            label="Data de Nascimento"
                            type="date" 
                            required
                            :validate="validate" 
                            :rules="['nasc']"
                            v-model="dados.paciente.cadastro.dt_nascimento" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input 
                            label="Sexo" 
                            type="sexo" 
                            required
                            :validate="validate"
                            v-model="dados.paciente.cadastro.ch_sexo" />
                    </div>
                </div>

                <div class="row" v-if="dados.paciente && dados.paciente.cadastro">
                    <div class="col col-12 col-md-6">
                        <az-input 
                            v-if="dados.paciente.cadastro.telefones"
                            label="Celular" 
                            type="fone" 
                            v-model="dados.paciente.cadastro.telefones.celular" 
                            required
                            :validate="validate" />
                    </div>
                    <div class="col col-12 col-md-6">
                        <az-input 
                            label="e-mail" 
                            type="email" 
                            v-model="dados.paciente.cadastro.st_email" 
                            :validate="validate" />
                    </div>
                </div>

                <div class="row" v-if="is_sus && dados.paciente && dados.paciente.cadastro">
                    <div class="col col-12 col-md-6">
                        <az-input 
                            label="Raça" 
                            type="select" 
                            v-model="dados.paciente.cadastro.st_raca" 
                            :optionsList="[
                                { id: '01', search: 'Branca' }, 
                                { id: '02', search: 'Preta' }, 
                                { id: '03', search: 'Parda' }, 
                                { id: '04', search: 'Amarela' }, 
                                { id: '05', search: 'Indígena' }, 
                            ]"
                            optionsData="id"
                            required
                            :validate="validate" />
                    </div>
                </div>

            </template>

        </template>

        <!-- Pedido -->

        <template v-if="step == 2">

            <div class="form-row" v-if="dados.paciente">
                <div class="col col-12">
                    <az-input
                        placeholder="Informe o nome do paciente..."
                        label="Paciente"
                        type="text"
                        :edicao="false"
                        v-model="dados.paciente.st_nome">
                        <template v-slot:buttonposb>
                            <div class="input-group-append">
                                <span class="input-group-text" id="basic-addon2" v-if="!dados.paciente.id_pessoa"><strong>Novo</strong></span>
                                <span class="input-group-text" id="basic-addon2" v-else>#{{ dados.paciente.id_pessoa }}</span>
                            </div>
                        </template>
                    </az-input>
                </div>
            </div>

            <div class="form-row">
                <div class="col col-12 col-md-2">
                    <az-input
                        ref="num_pedido"
                        id="num_pedido"
                        label="Número de Pedido de Origem"
                        placeholder="Informar..."
                        :validate="validate"
                        :edicao="!dados.edicao"
                        v-model="dados.origem" />
                </div>
            
                <div class="col col-12 col-md-2">
                    <az-input
                        label="Data do Atendimento"
                        type="date"
                        :edicao="!dados.edicao"
                        required
                        :validate="validate"
                        v-model="dados.data" />
                </div>

                <div class="col col-12 col-md-2">
                    <az-input
                        label="Hora do Atendimento"
                        type="time"
                        :edicao="!dados.edicao"
                        required
                        :validate="validate"
                        v-model="dados.hora" />
                </div>

                <div class="col col-12 col-md-6">
                    <az-input
                        label="Profissional Solicitante"
                        type="autocomplete"
                        optionsMode="aql"
                        service="medico_solicitantes.index"
                        optionsDisplay="search"
                        :optionsSync="true"
                        :validate="validate"
                        v-model="dados.medico_solicitante">
                    </az-input>
                </div>
            </div>

            <div class="form-row">

             
                <div class="col col-12 col-md-6" v-if="lista_recepcoes && lista_recepcoes.length > 1">
                    <az-input
                        label="Origem"
                        type="select"
                        :optionsList="lista_recepcoes"
                        optionsData="id_recepcao"
                        required
                        :validate="validate"
                        :edicao="!dados.edicao && !dados.id_atendimento"
                        v-model="dados.id_recepcao">
                    </az-input>
                </div>
            
                <div class="col col-12 col-md-6" v-if="$store.state.user.model.id_operadora && !$store.state.user.model.id_plano">
                    <az-input
                        :edicao="!dados.edicao && !dados.id_atendimento"
                        label="Cobrança"
                        type="select" 
                        optionsMode="aql"
                        optionsData="id_plano"
                        optionsDisplay="st_plano"
                        service="planos.index"
                        :optionsParm="{ 
                            id_operadora: $store.state.user.model.id_operadora, 
                            ativos: true, 
                        }"
                        optionsName="planos-apoiado"
                        placeholder="Selecione..."
                        required
                        :validate="validate"
                        v-model="dados.id_plano">
                    </az-input>
                </div>
            </div>

            <div class="form-row">
                <div class="col col-12">
                    <az-input
                        label="Observações"
                        v-model="dados.obs" />
                </div>
            </div>

        </template>

        <template v-if="step == 3">

            <div class="form-row" v-if="dados.paciente">
                <div class="col col-12 col-md-9">
                    <az-input
                        placeholder="Informe o nome do paciente..."
                        label="Paciente"
                        type="text"
                        :edicao="false"
                        v-model="dados.paciente.st_nome">
                        <template v-slot:buttonposb>
                            <div class="input-group-append">
                                <span class="input-group-text" id="basic-addon2" v-if="!dados.paciente.id_pessoa"><strong>Novo</strong></span>
                                <span class="input-group-text" id="basic-addon2" v-else>#{{ dados.paciente.id_pessoa }}</span>
                            </div>
                        </template>
                    </az-input>
                </div>

                <div class="col col-12 col-md-3">
                    <az-input
                        placeholder="Não informado"
                        label="Atendimento"
                        type="text"
                        :edicao="false"
                        v-model="dados.origem">
                        <template v-slot:buttonposb>
                            <div class="input-group-append">
                                <span class="input-group-text" id="basic-addon2" v-if="false"><strong>Novo</strong></span>
                            </div>
                        </template>
                    </az-input>
                </div>
            </div>

            <div class="mt-3">
                <div v-for="(exame, iex) in dados.exames" :key="iex">
                    <div class="form-row" v-if="exame.fl_ativo">
                        <div class="col col-12 col-md-9">
                            <template v-if="exame.procedimento">
                                <az-input
                                    :edicao="false"
                                    sizing="sm"
                                    v-if="exame.procedimento"
                                    v-model="exame.procedimento.search">
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <button type="button" class="btn btn-outline-danger" @click="exame.fl_ativo = false">
                                                <i class="fa fa-minus" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </template>
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <span class="input-group-text small" id="basic-addon2" v-if="exame.nao_coletar">
                                                Pendente
                                            </span>
                                            <span class="input-group-text small" id="basic-addon2" v-if="exame.procedimento && exame.procedimento.st_sigla" title="Sigla.">
                                                {{ exame.procedimento.st_sigla }}
                                            </span>
                                        </div>
                                    </template>
                                </az-input>
                            </template>
                        </div>

                        <div class="col col-12 col-md-3" v-if="exame.id_atendimento_procedimento && exame.amostra">
                            <az-input
                                v-if="exame.id_amostra_material && id_amostra_material_diversos && id_amostra_material_diversos[exame.id_amostra_material] && exame.js_solics && exame.js_solics.amo"
                                icon="fa-solid fa-vial"
                                sizing="sm" 
                                :edicao="false"
                                placeholder="Material..."
                                v-model="exame.js_solics.amo" />

                            <az-input
                                v-else
                                icon="fa-solid fa-vial"
                                sizing="sm" 
                                :edicao="false"
                                placeholder="Material..."
                                v-model="exame.amostra.search" />
                        </div>

                        <div class="col col-12 col-md-3" v-else-if="exame.procedimento && exame.procedimento.amostras && exame.procedimento.amostras.length">
                            <az-input
                                icon="fa-solid fa-vial"
                                sizing="sm" 
                                type="select"
                                placeholder="Material..."
                                :optionsList="exame.procedimento.amostras"
                                optionsDisplay="search"
                                optionsData="id_amostra_material"
                                required
                                :validate="validate"
                                v-if="!exame.id_atendimento_procedimento"
                                v-model="exame.id_amostra_material" />

                            <az-input   
                                sizing="sm"
                                placeholder="Descrição do Material..."
                                v-if="exame.id_amostra_material && id_amostra_material_diversos && id_amostra_material_diversos[exame.id_amostra_material]"
                                required
                                :validate="validate"
                                v-model="exame.amo" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- Seleção dos Exames -->
            <div class="form-row mt-3">
                <div class="col col-12">
                    <az-input
                        placeholder="Procedimento"
                        icon="fa fa-plus"
                        sizing="sm"
                        type="autocomplete"
                        optionsMode="aql"
                        optionsName2="procedimentos.combos.agenda"
                        :optionsName="'procedimentos.combos.agenda.op.' 
                            + ( dados.id_plano ? 'p.' + dados.id_plano : 'ppp' )
                            + ( dados.id_unidade_operacao ? '.uo' + dados.id_unidade_operacao : '' )"
                        :optionsParm="{ 
                            id_plano: dados.id_plano, 
                            id_unidade_operacao: dados.id_unidade_operacao 
                        }"
                        :optionsSync="false"
                        v-model="novoProcedimento"
                        ref="info_procedimento"
                        :procsigla="true"
                        @input="incluirProcedimento (null)">
                        <template v-slot:buttonposb>
                            <template v-if="1==0 && novoProcedimento && novoProcedimento.amostras && novoProcedimento.amostras.length">
                                <az-input
                                    :mb="false"
                                    sizing="sm"
                                    type="select"
                                    :optionsList="novoProcedimento.amostras"
                                    optionsData="id_amostra_material"
                                    placeholder="Selecione o material..."
                                    v-model="novoProcedimento.id_amostra_material"
                                    @onEnter="incluirProcedimento (null)">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <button type="button" class="btn btn-sm btn-outline-success" @click.prevent="incluirProcedimento (null, null, '')">
                                                <i class="fa-solid fa-check"></i>
                                            </button>
                                        </div>
                                    </template>
                                </az-input>
                            </template>
                        </template>

                    </az-input>
                </div>
            </div>

            <div class="mt-3" v-if="dados.logs && dados.logs.length">
                <ul class="list-group">
                    <li class="list-group-item list-group-item-danger" v-for="(log, ilx) in dados.logs" :key="ilx">
                        {{ log }}
                    </li>
                </ul>
            </div>

            <template v-if="dados.id_atendimento">

                <div class="mt-3 alert alert-primary d-flex justify-content-between" v-if="dados.id_atendimento">
                    <div>
                        <a href="#" @click.prevent="imprimir_etiquetas()" class="card-link">
                            <i class="fa fa-print mr-2" aria-hidden="true"></i> Imprimir Etiquetas 
                        </a>
                    </div>
                    <div>
                        #{{ dados.id_atendimento }}
                    </div>
                </div>

                <template v-if="dados.arquivos">

                    <div class="d-flex flex-column mb-3">
                        <button type="button" class="btn btn-lg"
                            :class="dados.arquivos.length ? 'btn-outline-dark' : 'btn-dark'"
                            @click="anexar()">
                            <i class="fa fa-check mr-2" aria-hidden="true" v-if="dados.arquivos.length"></i>
                            <i class="fa fa-paperclip mr-2" aria-hidden="true" v-else></i>
                            Anexar Arquivos
                        </button>
                    </div>

                    <az-file-upload
                        ref="upload"
                        @refresh="carregar_marcacao(dados.id_marcacao)"
                        :multiple="true"
                        :arquivos="dados.arquivos"
                        :blockcelular="true"
                        :parms="{
                            model_type: 'marcacao',
                            model_id: dados.id_marcacao,
                            id_atendimento: dados.id_atendimento, 
                            token: dados.st_token,
                            tipo_especial: 'paciente',
                        }" />

                </template>

            </template>

        </template>

        <pre v-if="false">{{ dados }}</pre>

        <!-- Fim -->

        <br><br><br>

        <!-- Barra de Navegação -->

        <nav class="navbar fixed-bottom navbar-light bg-light">
            <div>
                <span v-if="dados && dados.id_atendimento">
                    #{{ dados.id_atendimento }}
                    <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                </span>
                {{ step }} 
            </div>
            <div class="mr-3">
                <button type="button" class="btn btn-outline-secondary" @click="reset(true)">Reiniciar</button>
                <button type="button" class="btn btn-outline-success ml-1" @click="anterior()" :disabled="step == 1">Anterior</button>
                <az-submit @click="proximo()" color="success ml-1">{{ step == 3 ? 'Concluir' : 'Próximo' }}</az-submit>
            </div>
        </nav>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../cadastros/shared/ConfigMainTitle.vue'; 
import AzInput from '../shared/forms/AzInput.vue';
import CadastroPaciente from "../shared/CadastroPaciente.vue";
import AzSubmit from '../util/AzSubmit.vue';
import AzFileUpload from '../util/AzFileUpload.vue';

export default {
    data() { 
        return { 
            validate: false, 

            sel_paciente: "", 

            dados: { 
                paciente: "", 
                novo_paciente: false, 
                nome: "", 
                cpf: "",
                email: "",
                celular: "", 
                sexo: "",
                nascimento: "", 
                cartao_sus: "", 
                st_raca: "", 
                data: "",
                hora: "",
                id_plano: "",  
                medico_solicitante: {},
                exames: [], 
                logs: [], 
            },

            is_sus: false, 

            step: 1, 

            novoProcedimento: "", 
            imprimindo_etiquetas: false, 

            id_amostra_material_diversos: null, 
        }
    },

    components: { 
        ConfigMainTitle,
        AzInput, 
        CadastroPaciente, 
        AzSubmit, 
        AzFileUpload, 
    },

    computed: { 
        lista_recepcoes: function () { 
            return _.orderBy(
                this.$store.state.user.model.deparas.map(item => item.model),
                'st_nome'
            );
        },
    },

    methods: { 
        anexar() {
            this.$refs.upload.abrir();
        },

        imprimir_etiquetas () { 
            if ( !confirm('Confirma impressão das etiquetas?') ) { 
                return;
            }

            this.imprimindo_etiquetas = true; 

            this.$util.atualizar(this, { 
                service: 'apoiados',
                func: 'etiquetas', 
                redir_api: true, 
                dados: { 
                    lista: [
                        { 
                            id_atendimento: this.dados.id_atendimento, 
                        }
                    ], 
                },
                callback: () => { 
                    this.imprimindo_etiquetas = false;
                }
            });
        },

        incluirProcedimento (novo = null) {

            if ( !this.novoProcedimento ) { 
                return;
            }

            let lista = [];

            if ( this.novoProcedimento && Array.isArray(this.novoProcedimento) ) {

                lista = this.novoProcedimento

            } else { 

                lista = [
                    novo ? novo : this.novoProcedimento
                ];

            }

            this.novoProcedimento = null;

            this.$nextTick(() => { 
                this.novoProcedimento = "";
            
                lista.forEach(item => { 

                    this.$util.load(this, { 
                        service: 'procedimentos',
                        func: 'show',
                        parms: { 
                            id: item.id_procedimento, 
                            amostras: true, 
                        },
                        loadTo: res => { 

                            let id_amostra_material = ( res.amostras && res.amostras.length == 1 ) ? res.amostras[0].id_amostra_material : "";

                            if ( id_amostra_material && res.amostras && res.amostras.length > 1 ) { 
                                let amostra = res.amostras.find(amostra => amostra.fl_padrao);

                                if ( !amostra ) { 
                                    amostra = res.amostras.find(amostra => amostra.in_regra_ordem == 1);
                                }

                                if ( amostra ) { 
                                    id_amostra_material = amostra.id_amostra_material;
                                }
                            }

                            this.dados.exames.push({
                                id_atendimento_procedimento: null,
                                procedimento: res, 
                                in_quantidade: 1, 
                                fl_ativo: true, 
                                nao_coletar: true, 
                                id_amostra_material: ( res.amostras && res.amostras.length == 1 ) ? res.amostras[0].id_amostra_material : "", 
                            });

                        }
                    })

                });
            });

        },

        reset (confirmar = false) { 
            if ( confirmar ) { 
                if ( !confirm("Confirma reiniciar o lançamento?") ) { 
                    return;
                }
            }

            this.validate = false;
            this.sel_paciente = "";
            this.step = 1;
            
            this.dados = { 
                paciente: "", 
                novo_paciente: false, 
                nome: "", 
                cpf: "",
                email: "",
                celular: "", 
                sexo: "",
                nascimento: "", 
                cartao_sus: "", 
                st_raca: "", 
                id_plano: this.$store.state.user.model.id_plano ? this.$store.state.user.model.id_plano : "",
                id_recepcao: this.$store.state.user.model.id_recepcao, 
                data: this.$util.hoje(),
                hora: this.$util.agora(), 
                edicao: false, 
                medico_solicitante: {},
                exames: [], 
                logs: [], 
            };

            this.$nextTick(() => { 
                this.focusOn('info_paciente');
            });
        }, 

        focusOn (item) {
            if ( this.$refs[item] && this.$refs[item].$refs && this.$refs[item].$refs.input ) {
                this.$refs[item].$refs.input.focus ();
            }
        },

        validar() { 
            this.validate = true; 

            this.$nextTick(() => { 

                let invalids = $(".invalid");

                if (invalids.length && $(".invalid").is(":visible")) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Verificar preenchimento dos campos.",
                        life: 3000
                    });

                    return;
                }

                this.validate = false; 
                this.step = this.step + 1;  

            });
        },

        anterior() { 
            this.validate = false; 
            this.step = this.step - 1; 
        },

        proximo() { 
            if ( this.step == 3 ) { 
                this.concluir();
                return;
            }

            this.validar();
        },

        toggle_incluir_paciente () { 
            if ( !this.dados.novo_paciente ) { 
                this.dados.paciente = { 
                    st_nome: "", 
                    cadastro: { 
                        st_cpf: "",
                        dt_nascimento: "", 
                        ch_sexo: "",
                        st_email: "", 
                        telefones: { 
                            celular:  "", 
                        }, 
                        st_raca: "", 
                    },
                    paciente_unidade: { 
                        plano: "", 
                        st_sus: "", 
                    }
                };
            } else { 
                this.dados.paciente = null;
            }
            this.dados.novo_paciente = !this.dados.novo_paciente;

            this.$nextTick(() => { 
                this.focusOn('info_paciente');
                this.$forceUpdate();
            });
        },

        selecionarPaciente() { 
            if ( this.sel_paciente ) { 
                this.dados.paciente = _.cloneDeep(this.sel_paciente);
            }
        }, 

        concluir () { 
            this.$util.atualizar(this, { 
                service: 'apoiados',
                func: 'cadastrar_pedido',
                dados: { 
                    pedido: this.dados, 
                }, 
                toast: true, 
                callback: res => { 
                    if ( !this.dados.id_atendimento 
                        && _.get(res, 'gerado.retorno.id_klingo') 
                        && _.get(res, 'id_marcacao') 
                        && _.get(res, 'st_token') ) { 

                        this.dados.arquivos = [];
                        this.dados.id_marcacao = _.get(res, 'id_marcacao');
                        this.dados.st_token = _.get(res, 'st_token');
                    }

                    this.dados.logs = _.get(res, 'gerado.retorno.logs');
                    this.dados.id_atendimento = _.get(res, 'gerado.retorno.id_klingo');
                }
            });
        },

        carregar_marcacao (id_marcacao) { 

            this.$util.load(this, { 
                service: 'marcacoes',
                func: 'show',
                parms: { 
                    id: id_marcacao, 
                    lancamento_procedimento: true, 
                },
                loadTo: res => { 
                    this.dados.paciente = res.paciente;
                    this.dados.novo_paciente = false;
                    this.dados.id_recepcao = res.id_recepcao;
                    this.dados.data = res.dt_inicio.slice(0,10);
                    this.dados.hora = res.dt_inicio.slice(11,16);
                    this.dados.origem = res.st_codigo_reserva;
                    this.dados.obs = res.st_observacoes; 
                    this.dados.id_marcacao = res.id_marcacao;
                    this.dados.id_atendimento = res.id_atendimento;
                    this.dados.arquivos = res.arquivos;
                    this.dados.st_token = res.st_token; 

                    if ( res.atendimento.medico_solicitante ) { 
                        this.dados.medico_solicitante = res.atendimento.medico_solicitante;
                    }

                    this.dados.exames = res.atendimento.atendimento_procedimentos.filter(atp => atp.laudo);
                    this.dados.edicao = true; 

                    //medico_solicitante: {},
                    //exames: [], 
                    //logs: [], 
                }
            });

        }
    },

    mounted() { 
        this.focusOn('info_paciente');
        this.reset();

        if ( this.id_amostra_material_diversos === null ) { 
            
            this.$util.loadItem(this, { 
                service: 'amostra_materiais',
                func: 'index', 
                parms: { 
                    where: { 
                        st_codigo: 'DIV',
                    }
                }
            })
            .then(res => { 
                this.id_amostra_material_diversos = {};
                
                res.forEach(item => { 
                    this.$set(this.id_amostra_material_diversos, item.id_amostra_material, item);
                });
            });

        }

        if ( this.$route.params.id_marcacao ) { 
            this.$util.loadItem(this, { 
                service: 'marcacoes',
                func: 'show',
                parms: { 
                    id: this.$route.params.id_marcacao, 
                    lancamento_procedimento: true, 
                }
            })
            .then(res => { 
                this.dados.paciente = res.paciente;
                this.dados.novo_paciente = false;
                this.dados.id_recepcao = res.id_recepcao;
                this.dados.id_plano = res.id_plano;
                this.dados.data = res.dt_inicio.slice(0,10);
                this.dados.hora = res.dt_inicio.slice(11,16);
                this.dados.origem = res.st_codigo_reserva;
                this.dados.obs = res.st_observacoes; 
                this.dados.id_marcacao = res.id_marcacao;
                this.dados.id_atendimento = res.id_atendimento;
                this.dados.arquivos = res.arquivos;
                this.dados.st_token = res.st_token; 

                if ( res.atendimento.medico_solicitante ) { 
                    this.dados.medico_solicitante = res.atendimento.medico_solicitante;
                }

                if ( res.atendimento ) { 
                    this.dados.obs = res.atendimento.st_observacao;
                }

                console.log('res', res);

                this.dados.exames = res.atendimento.atendimento_procedimentos.filter(atp => atp.laudo);
                this.dados.edicao = true; 

                //medico_solicitante: {},
                //exames: [], 
                //logs: [], 
            });
        }
    }
}
</script>
